var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTagUser = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "#292D32",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}, /*#__PURE__*/React.createElement("path", {
  d: "M18 18.86h-.76a3 3 0 0 0-2.12.87l-1.71 1.69a2.02 2.02 0 0 1-2.83 0l-1.71-1.69a3 3 0 0 0-2.12-.87H6a2.98 2.98 0 0 1-3-2.97V4.97A2.983 2.983 0 0 1 6 2h12a2.983 2.983 0 0 1 3 2.97v10.91a2.99 2.99 0 0 1-3 2.98"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.071 8.952h-.15a1.95 1.95 0 1 1 2.02-1.95 1.923 1.923 0 0 1-1.87 1.95M9.254 11.96a1.806 1.806 0 0 0 0 3.23 5.37 5.37 0 0 0 5.5 0 1.806 1.806 0 0 0 0-3.23 5.42 5.42 0 0 0-5.5 0"
}))));
export { SvgTagUser as ReactComponent };
export default __webpack_public_path__ + "8ceea037340e14e062ac910ba7243685.svg";